import "./App.css";
import Home from "./pages/Home";
import { BrowserRouter as Router, Switch, Route, Routes } from "react-router-dom";
import SearchPage from "./pages/SearchPage";

function App() {
  return (
    <div className="app">
      <Router>
        <Routes>
          <Route path="/search" element={<SearchPage />}>
            
          </Route>
          <Route path="/" element={<Home />}>
            
          </Route>
          </Routes>
      </Router>
    </div>
  );
}

export default App;
